"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsteriskStatusEnum = void 0;
var AsteriskStatusEnum;
(function (AsteriskStatusEnum) {
    AsteriskStatusEnum["Syncing"] = "Syncing";
    AsteriskStatusEnum["Terminated"] = "Terminated";
    AsteriskStatusEnum["Offline"] = "Offline";
    AsteriskStatusEnum["Booting"] = "Booting";
    AsteriskStatusEnum["UpAndRunning"] = "UpAndRunning";
})(AsteriskStatusEnum = exports.AsteriskStatusEnum || (exports.AsteriskStatusEnum = {}));
